export const networkLogoClassNameMap = {
  'A&E': 'network-banner__a-and-e',
  ABC: 'network-banner__abc',
  'Acorn TV': 'network-banner__acorn-tv',
  'Adult Swim': 'network-banner__adult-swim',
  ALLBLK: 'network-banner__allblk',
  'Ambient.tv': 'network-banner__ambient',
  AMC: 'network-banner__amc',
  'AMC Premiere': 'network-banner__amc-premiere',
  'American Heroes': 'network-banner__american-heroes',
  'Animal Planet': 'network-banner__animal-planet',
  'Anime Network': 'network-banner__anime-network',
  Bandamax: 'network-banner__bandamax',
  'BBC America': 'network-banner__bbc-america',
  'BBC World News': 'network-banner__bbc-world-news',
  'beIN Sports': 'network-banner__bein-sports',
  'beIN Sports Español': 'network-banner__bein-sports-espanol',
  BET: 'network-banner__bet',
  Bravo: 'network-banner__bravo',
  Boomerang: 'network-banner__boomerang',
  'Cartoon Network': 'network-banner__cartoon-network',
  CBS: 'network-banner__cbs',
  Cinemax: 'network-banner__cinemax',
  CMT: 'network-banner__cmt',
  CNBC: 'network-banner__cnbc',
  CNN: 'network-banner__cnn',
  'CNN en Español': 'network-banner__cnn-en-espanol',
  'Comedy Central': 'network-banner__comedy-central',
  'Common Sense Media': 'network-banner__common-sense-media',
  'Cooking Channel': 'network-banner__cooking-channel',
  'Crime Investigation': 'network-banner__crime-investigation',
  'Destination America': 'network-banner__destination-america',
  'Discovery Channel': 'network-banner__discovery-channel',
  'Discovery en Español': 'network-banner__discovery-en-espanol',
  'Discovery Family': 'network-banner__discovery-family',
  'Discovery Life': 'network-banner__discovery-life',
  'Disney Channel': 'network-banner__disney-channel',
  'Disney Junior': 'network-banner__disney-junior',
  'Disney XD': 'network-banner__disney-xd',
  'E!': 'network-banner__e-network',
  ESPN: 'network-banner__espn',
  'ESPN Deportes': 'network-banner__espn-deportes',
  'Familia Discovery': 'network-banner__familia-discovery',
  'Food Network': 'network-banner__food-network',
  Fox: 'network-banner__fox',
  'Fox Deportes': 'network-banner__fox-deportes',
  'Fox Sports 1': 'network-banner__fox-sports-one',
  Freeform: 'network-banner__freeform',
  Fuse: 'network-banner__fuse',
  FX: 'network-banner__fx',
  FXM: 'network-banner__fxm',
  FXX: 'network-banner__fxx',
  FYI: 'network-banner__fyi',
  'GAIAM TV': 'network-banner__gaiam-tv',
  Galavision: 'network-banner__galavision',
  'Game Show Network': 'network-banner__game-show-network',
  'Golf Channel': 'network-banner__golf-channel',
  'Hallmark Channel': 'network-banner__hallmark-channel',
  Max: 'network-banner__max',
  HGTV: 'network-banner__hgtv',
  History: 'network-banner__history',
  'History en Español': 'network-banner__history-en-espanol',
  HLN: 'network-banner__hln',
  IFC: 'network-banner__ifc',
  'Investigation Discovery': 'network-banner__investigation-discovery',
  'K Pop TV': 'network-banner__k-pop-tv',
  Kabillion: 'network-banner__kabillion',
  'Kabillion Girls Rule': 'network-banner__kabillion-girls-rule',
  KLIFE: 'network-banner__klife',
  Lifetime: 'network-banner__lifetime',
  LMN: 'network-banner__lmn',
  Logo: 'network-banner__logo-network',
  'Magnolia Network': 'network-banner__magnolia-network',
  'MGM+': 'network-banner__mgm-plus',
  'Military History': 'network-banner__military-history',
  'MLB Network': 'network-banner__mlb-network',
  MotorTrend: 'network-banner__motortrend',
  Movieplex: 'network-banner__movieplex',
  MSNBC: 'network-banner__msnbc',
  MTV: 'network-banner__mtv',
  'MTV Classic': 'network-banner__mtv-classic',
  'MTV Live': 'network-banner__mtv-live',
  MTV2: 'network-banner__mtv-two',
  'Music Choice': 'network-banner__music-choice',
  'National Geographic': 'network-banner__national-geographic',
  'National Geographic Wild': 'network-banner__national-geographic-wild',
  NBC: 'network-banner__nbc',
  'NBC News': 'network-banner__nbc-news',
  'NBC Universo': 'network-banner__nbc-universo',
  NBCSN: 'network-banner__nbcsn',
  'NFL Network': 'network-banner__nfl-network',
  'Nick at Night': 'network-banner__nick-at-nite',
  'Nick En Español': 'network-banner__nick-en-espanol',
  'Nick Jr.': 'network-banner__nick-jr',
  Nickelodeon: 'network-banner__nickelodeon',
  'Outdoor Channel': 'network-banner__outdoor-channel',
  Ovation: 'network-banner__ovation',
  OWN: 'network-banner__own',
  Oxygen: 'network-banner__oxygen',
  'Paramount Network': 'network-banner__paramount-network',
  PBS: 'network-banner__pbs',
  Pop: 'network-banner__pop',
  Reelz: 'network-banner__reelz',
  Revolt: 'network-banner__revolt',
  'Science Channel': 'network-banner__science-channel',
  'Paramount+ with Showtime': 'network-banner__showtime',
  Shudder: 'network-banner__shudder',
  'Smithsonian Channel': 'network-banner__smithsonian-channel',
  Sportskool: 'network-banner__sportskool',
  STARZ: 'network-banner__starz',
  'STARZ ENCORE': 'network-banner__starz-encore',
  'Sundance Now': 'network-banner__sundance-now',
  'Sundance TV': 'network-banner__sundance-tv',
  SYFY: 'network-banner__syfy',
  TBS: 'network-banner__tbs',
  TCM: 'network-banner__tcm',
  Telemundo: 'network-banner__telemundo',
  TFC: 'network-banner__tfc',
  'The CW': 'network-banner__the-cw',
  'The Weather Channel': 'network-banner__the-weather-channel',
  TLC: 'network-banner__tlc',
  TNT: 'network-banner__tnt',
  tr3s: 'network-banner__tres-network',
  'Travel Channel': 'network-banner__travel-channel',
  truTV: 'network-banner__tru-tv',
  TUDN: 'network-banner__tudn',
  'TV Land': 'network-banner__tv-land',
  'TV One': 'network-banner__tv-one',
  Unimas: 'network-banner__unimas',
  'Universal Kids': 'network-banner__universal-kids',
  'Universal Kids En Español': 'network-banner__universal-kids-en-espanol',
  Univision: 'network-banner__univision',
  Up: 'network-banner__up',
  USA: 'network-banner__usa',
  VH1: 'network-banner__vh-one',
  Vice: 'network-banner__vice',
  'Viendo Movies': 'network-banner__viendo-movies',
  'WE TV': 'network-banner__we-tv',
  'WGN America': 'network-banner__wgn-america',
};
